export type ImageType = 'ORIGINAL' | 'THUMBNAIL' | 'LARGE' | 'SMALL' | 'UNKNOWN';

export interface ImageSize {
  url: string;
  width: number;
  height: number;
  number: number;
  type: ImageType;
}

export interface Image {
  url: string;
  width: number;
  height: number;
  type: ImageType;
  number: number;
  sizes: ImageSize[];
}

export const findImageSizeUrl = (
  image: Image,
  imageType: ImageType,
  fallbackToOriginal = true,
): string | undefined => {
  const matched = image.sizes.find((size) => size.type === imageType);
  if (matched) return matched.url;

  return fallbackToOriginal ? image.url : undefined;
};

export const getImageSizeUrl = (image: Image, imageType: ImageType): string => {
  const matched = image.sizes.find((size) => size.type === imageType);
  return matched?.url || image.url;
};

export const findImageThumbnailUrl = (image: Image): string | undefined =>
  findImageSizeUrl(image, 'THUMBNAIL');

export const getImageThumbnailUrl = (image: Image): string => getImageSizeUrl(image, 'THUMBNAIL');
